import { useState } from "react";
import cancelImg from "../assets/images/cancel.png"
import { useDeleteTodoMutation, useEditTodoMutation,  } from "../features/api/apiSlice";
import Modal from "./Modal";
import CheckBoxLoader from "./ui/loaders/CheckBoxLoader";
export default function Todo({ todo }) {
    let { id, text, completed, color } = todo;
    
    const [editTodo, {isLoading, isSuccess, isError}] = useEditTodoMutation();
    const [deleteTodo, {isLoading: delLoading, isSuccess: delSuccess, isError: delError}] = useDeleteTodoMutation();

    const [modalOn, setModalOn] = useState(false);
    const [choice, setChoice] = useState(false)
    // const [newColor, setNewcolor] = useState(color);

    const handleEdit = () => {
        setModalOn(true)
    }
    
    const handleColorChange = (id, color) => {
        editTodo({
            id,
            data: {
                color,
            },
        });
    };

    const deleteImg = () => {
        deleteTodo(id);
    }

    const handleComplete = () => {
        if(completed){
            completed = false;
        }else{
            completed = true;
        }
        // console.log(completed);
        editTodo({
            id,
            data: {
                completed,
            },
        });
    }
    return (
        <div
            className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0"
        >
            <div
                className="rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 border-green-500 focus-within:border-green-500"
            >
                {isLoading ? <CheckBoxLoader /> : <input
                    type="checkbox"
                    className="opacity-0 absolute rounded-full"
                    onClick={handleComplete}
                />}
                <svg
                    className={`${!completed ? 'hidden' : 'fill-current w-3 h-3 text-green-500 pointer-events-none' }`}
                    viewBox="0 0 20 20"
                >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
            </div>
            {/* line-through  */}
            <div className={`select-none flex-1 ${completed && 'line-through'}`} onClick={handleEdit}>
                {text}
            </div>

            <div
                 className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
                    color === "green" && "bg-green-500"
                }`}
                onClick={() => handleColorChange(id, "green")}
            ></div>

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
                    color === "yellow" && "bg-yellow-500"
                }`}
                onClick={() => handleColorChange(id, "yellow")}
            ></div>

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
                    color === "red" && "bg-red-500"
                }`}
                onClick={() => handleColorChange(id, "red")}
            ></div>

            <img
                src={cancelImg}
                className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                alt="Cancel"
                onClick={deleteImg}
            />
            {/* {choice &&
                <div className="flex justify-center">
                    <div className="flex  justify-center w-1/3 bg-red-400 m-4 p-6 text-lg text-white "> You have been bitten !!!</div>
                </div>
            } */}

            {modalOn && <Modal setModalOn={setModalOn} setChoice={setChoice} id={id} />}
        </div>
    );
}